import { Outlet, useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useTheme } from '../contexts/ThemeContext'
import MinimalCookieConsent from '../components/common/MinimalCookieConsent'

const AuthLayout = () => {
  const navigate = useNavigate()
  const { theme } = useTheme()
  const [logoLoaded, setLogoLoaded] = useState(false)

  return (
    <div className="min-h-screen flex flex-col justify-center py-12 responsive-py-3">
      <div className="responsive-container responsive-max-w-md mx-auto w-full">
        {/* Logo */}
        <div className="text-center mb-8 responsive-mb-4">
          <img 
            src={theme === 'dark' ? "/wp-high-resolution-logo-darkmode.svg" : "/wp-high-resolution-logo-transparent.svg"} 
            alt="WhistlePro" 
            className={`auth-logo responsive-touch-target mx-auto cursor-pointer ${logoLoaded ? 'loaded' : 'loading'}`}
            onClick={() => navigate('/')}
            onLoad={() => setLogoLoaded(true)}
          />
        </div>
        
        {/* Auth Content */}
        <div className="bg-white rounded-lg shadow-lg responsive-p-4 md:p-8">
          <Outlet />
        </div>
        
        {/* Footer Links */}
        <div className="mt-8 text-center text-sm text-gray-600 responsive-text-xs">
          <a href="/" className="hover:text-gray-900 responsive-touch-target inline-block">
            Back to Home
          </a>
          <span className="mx-2">•</span>
          <a href="/privacy" className="hover:text-gray-900 responsive-touch-target inline-block">
            Privacy Policy
          </a>
          <span className="mx-2">•</span>
          <a href="/terms" className="hover:text-gray-900 responsive-touch-target inline-block">
            Terms of Service
          </a>
        </div>
      </div>
      
      {/* Cookie Consent - Only shown on auth routes */}
      <MinimalCookieConsent />
    </div>
  )
}

export default AuthLayout